import { send } from '../../../../../../src/network';
import {
  type CustomerRatableProduct,
  type PaginatedCustomerRatableProductFeedbackModalList,
} from '../../../../../../src/types/PaginatedCustomerRatableProductFeedbackModalList';
export { type CustomerRatableProduct };

export type Params = {
  bypass_viewed?: boolean;
  limit?: string;
  offset?: string;
  recent_order_count?: number;
  customerId: number;
  recent_order_date?: string;
};

export async function getApiV2CustomersCustomerIdRatableProductsFeedbackModal(
  params: Params
) {
  const queryParams = new URLSearchParams();

  if (params.bypass_viewed !== undefined) {
    queryParams.append('bypass_viewed', params.bypass_viewed.toString());
  }

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit);
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset);
  }

  if (params.recent_order_count !== undefined) {
    queryParams.append(
      'recent_order_count',
      params.recent_order_count.toString()
    );
  }

  if (params.recent_order_date !== undefined) {
    queryParams.append('recent_order_date', params.recent_order_date);
  }

  return await send<PaginatedCustomerRatableProductFeedbackModalList>({
    path: `/api/v2/customers/${params.customerId}/ratable_products_feedback_modal/`,
    method: 'GET',
    query: queryParams,
  });
}
